import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withCmsForm from 'modules/common/hoc/withCmsForm';
import FilePondSingleUpload from 'uploader/FilePondSingleUpload';
import ImagePlaceholder from 'assets/img/image-placeholder.jpg';
import * as actions from '../action';
import * as c from '../constant';

const CMS_TYPE = 'LOGOS'


const fields = [
  'MAIN_LOGO',
  'SECONDARY_LOGO',
  'SIMPLE_LOGO',
  'LOGO',
  'CORE_LOGO',
  'CORE_LOGO_WHITE',
  'FAVICON',
  'PAYMENTS',
  'FOOTER_LOGO',
  'FOOTER_LOGO_CORE',
  'LOGO_DARK',
  'TREASURER_LOGO'
]

const formatLabel = value =>
  value
    .split('_')
    .join(' ')
    .toLowerCase()
    .replace(/\b\w/g, char => char.toUpperCase());

// const DEFAULT_IMAGE = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='180' height='120' viewBox='0 0 180 120'%3E%3Crect width='180' height='120' fill='%23f3f6fa'/%3E%3Cpath d='M24 92l32-34 24 24 18-18 58 28H24z' fill='%23d7dfe8'/%3E%3Ccircle cx='62' cy='42' r='10' fill='%23d7dfe8'/%3E%3Ctext x='90' y='108' text-anchor='middle' font-size='12' fill='%238898a8' font-family='Arial'%3ENo Image%3C/text%3E%3C/svg%3E";

function Icons({ getList, item, setFormData, createHidden, create, update, formData }) {
  const [imageLoading, setImageLoading] = useState({});
  const [imageError, setImageError] = useState({});
  const previousImageSources = useRef({});

  const getImageSource = field => {
    const fieldValue = _.get(formData, field);
    const cdnUrl = _.get(formData, `${field}.cdnUrl`) || _.get(fieldValue, 'cdnUrl') || _.get(fieldValue, 'url');

    if (_.isString(cdnUrl) && cdnUrl.trim()) {
      return cdnUrl;
    }

    if (_.isString(fieldValue) && fieldValue.trim()) {
      return fieldValue;
    }

    return '';
  };

  useEffect(() => {
    getList({ type: CMS_TYPE })
  }, [])

  useEffect(() => {
    setFormData({
      ...JSON.parse(_.get(item, 'attributes.body') || '{}'),
      id: _.get(item, 'id')
    })
  }, [item])

  useEffect(() => {
    const currentSources = fields.reduce((acc, field) => {
      acc[field] = getImageSource(field);
      return acc;
    }, {});

    const changedFields = fields.filter(
      field => previousImageSources.current[field] !== currentSources[field]
    );

    previousImageSources.current = currentSources;

    if (!changedFields.length) {
      return;
    }

    setImageLoading(prev => {
      const nextState = { ...prev };
      changedFields.forEach(field => {
        nextState[field] = !!currentSources[field];
      });
      return nextState;
    });

    setImageError(prev => {
      const nextState = { ...prev };
      changedFields.forEach(field => {
        nextState[field] = false;
      });
      return nextState;
    });
  }, [formData]);

  const handleOnSubmit = e => {
    e.preventDefault()

    if(_.get(formData, 'id')){
      return update(
        _.get(formData, 'id'),
        {
        body: JSON.stringify(_.pick(formData, fields))
      })
    }

    return create({
      body: JSON.stringify(_.pick(formData, fields))
    })
  }

  const onChangePhoto = key => (value) => {
    setFormData({
      ...formData,
      [key]: value,
    });
  };

  return (
    <div className="card border-0 shadow-sm">
      <div className="card-body p-4 p-lg-5">
        <form onSubmit={handleOnSubmit}>
          {createHidden(
            { key: 'id' },
            { placeholder: '' }
          )}
          <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between mb-3">
            <div>
              <h5 className="mb-1 font-weight-bold">Logo Library</h5>
              <p className="mb-0 text-muted">
                Upload and manage logo assets.
              </p>
            </div>
          </div>
          <div className="row">
            {fields.map(field => {
              // all fields required except TREASURER_LOGO
              const isRequired = field !== 'TREASURER_LOGO';
              const imageSource = getImageSource(field);
              const hasImage = !!imageSource && !imageError[field];

              return (
                <div key={field} className="col-12 col-md-6 col-lg-3 mb-3">
                  <div className="border rounded bg-white shadow-sm p-3 mb-2">
                    <p className="form-label font-weight-bold text-center m-0 mb-2 mr-1">{formatLabel(field)}</p>
                    <div
                      className="d-flex justify-content-center align-items-center position-relative border rounded bg-light p-2 overflow-hidden"
                      style={{ minHeight: 140 }}
                    >
                      {imageLoading[field] && hasImage && (
                        <div className="position-absolute w-100 h-100 d-flex justify-content-center align-items-center">
                          <span className="fas fa-2x fa-spin fa-spinner text-info" />
                        </div>
                      )}
                      <img
                        className="img-fluid"
                        style={{
                          width: '100%',
                          maxWidth: 160,
                          maxHeight: 120,
                          objectFit: 'contain',
                          opacity: imageLoading[field] && hasImage ? 0 : 1
                        }}
                        alt={formatLabel(field)}
                        src={hasImage ? imageSource : ImagePlaceholder}
                        onLoad={() => setImageLoading(prev => ({ ...prev, [field]: false }))}
                        onError={() => {
                          setImageLoading(prev => ({ ...prev, [field]: false }));
                          setImageError(prev => ({ ...prev, [field]: true }));
                        }}
                      />
                    </div>
                    <FilePondSingleUpload onChange={onChangePhoto(field)} required={isRequired && !hasImage} />
                  </div>
                  {/* <div className="border rounded bg-white p-3">
                    {createUploader(
                      { key: field, label: `${formatLabel(field)}:` },
                      { required: isRequired, placeholder: '' }
                    )}
                  </div> */}
                </div>
              )
            })}
          </div>
  
          <div className="d-flex justify-content-center pt-2">
            <button
              // disabled={creating}
              type="submit"
              className="btn btn-primary cms-bg-color-primary cms-outline-primary px-4 font-weight-bold"
            >
              <span className="font-weight-bold">
                {/* {creating ? <i className="fa fa-spin fa-spinner" /> : `Submit`} */}
                Submit
              </span>
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}


Icons.propTypes = {
  getList: PropTypes.instanceOf(Function).isRequired,
  // createInput: PropTypes.instanceOf(Function).isRequired,
  createHidden: PropTypes.instanceOf(Function).isRequired,
  item: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  create: PropTypes.instanceOf(Function).isRequired,
  update: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  // createUploader: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  item: (_.get(api, `${c.GET_SETTINGS}.list`) || [])[0] || {},
});

const enhance = _.flowRight([withCmsForm, withRouter, connect(mapStateToProps, actions)]);

export default enhance(Icons);
